'use client';

import { useTranslations } from '@dealerportal/i18n/client';

type PricingSectionProps = {
  brandName: string;
  unitPrice?: number;
  pricePerBox?: number;
  priceDescription?: string;
  pricingMessage?: string;
  additionalMessage?: string;
};

export const PricingSection = (props: PricingSectionProps) => {
  const t = useTranslations('products');
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {props.unitPrice || props.pricePerBox ? (
        <div className="!ui-mt-8 ui-flex ui-items-center ui-gap-4">
          <div className="ui-flex ui-items-center ui-gap-1.5">
            {props.unitPrice && (
              <>
                <div className="ui-text-3xl ui-font-bold ui-leading-none ui-text-gray-800">
                  {`$${props.unitPrice.toFixed(2)}`}
                </div>
                /
                <div className="ui-relative ui-text-xs ui-text-gray-800 ui-font-bold ui-leading-none">
                  {props.priceDescription}
                </div>
              </>
            )}
          </div>
          {props.pricePerBox && (
            <>
              <div className="ui-h-8 ui-w-px ui-bg-gray-300" />
              <div className="ui-flex ui-items-center ui-gap-1.5">
                <div className="ui-text-3xl ui-font-bold ui-leading-none ui-text-gray-800">
                  {`$${props.pricePerBox.toFixed(2)}`}
                </div>
                /
                <div className="ui-relative ui-text-xs ui-text-gray-800 ui-font-bold ui-leading-none">
                  {t('case')}
                </div>
              </div>
            </>
          )}
          {!props.unitPrice && props.pricingMessage && (
            <div className="!ui-mt-6">
              <div className="ui-text-xl ui-leading-none">
                {props.pricingMessage}
              </div>
            </div>
          )}
        </div>
      ) : (
        <>
          {/** Canopy Floors products cannot show "Call For Price" */}
          {props.brandName !== 'Canopy Floors' && (
            <div className="!ui-mt-6 ui-text-xl ui-leading-none ui-font-semibold">
              {t('callForPrice')}
            </div>
          )}
        </>
      )}
    </>
  );
};
